import {
  MESSAGE_FIRST_NUMBER_NO_VALID,
  MESSAGE_PHONE_NUMBER_LENGTH,
  MESSAGE_PHONE_REQUIRED,
  phoneRegExp,
  validPhoneCodes
} from 'const';
import yup from 'core/utils/validators';

const { object, string } = yup;

export const phoneLoginFormSchema = () =>
  object().shape({
    username: string()
      .validateCodePhone(validPhoneCodes, MESSAGE_FIRST_NUMBER_NO_VALID)
      .matches(phoneRegExp, MESSAGE_PHONE_NUMBER_LENGTH)
      .required(MESSAGE_PHONE_REQUIRED),
  });
